module.exports = require('./RadialProgressBar.vue').default